import React, {
    useState,
    useEffect,
    useContext,
    Fragment,
    useCallback,
} from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DivLayout from 'components/sales/divLayout/divLayout';

const SiteVisitDetails = ({
                              siteVisitById,
                              siteVisitByIdDetails = [],
                              match,
                              history,
                          }) => {
    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);

    const getMeeting = useCallback(async () => {
        setIsLoading(true);
        await siteVisitById(match?.params?.id);
        setIsLoading(false);
    }, []);

    useEffect(() => {
        getMeeting();
    }, [getMeeting]);

    {
        console.log(siteVisitByIdDetails)
    }

    return (
        <Layout
            title={localization.siteVisitTask}
            isGoback
            isLoading={isLoading}
            linkFlag
            linkUrl={`${baseUrl}/site-visit-list`}
        >
            {siteVisitByIdDetails && siteVisitByIdDetails.data && Object.keys(siteVisitByIdDetails?.data).length !== 0 &&
                <>
                    <div className="panel-card">
                        <div className="panel-heading">{localization.carnivalDetails}</div>
                        <div className="panel-body">
                            <div className="details-listing">
                                <DivLayout
                                    heading={'Engineer Name'}
                                    data={
                                        siteVisitByIdDetails?.data?.name
                                            ? siteVisitByIdDetails?.data?.name
                                            : ''
                                    }
                                />
                                <DivLayout
                                    heading={"Client Name"}
                                    data={
                                        siteVisitByIdDetails?.data?.client_name
                                            ? siteVisitByIdDetails?.data?.client_name
                                            : ''
                                    }
                                />
                                <DivLayout
                                    heading={localization.lat}
                                    data={
                                        siteVisitByIdDetails?.data?.lat
                                            ? siteVisitByIdDetails?.data?.lat
                                            : ''
                                    }
                                />
                                <DivLayout
                                    heading={localization.lng}
                                    data={
                                        siteVisitByIdDetails?.data?.long
                                            ? siteVisitByIdDetails?.data?.long
                                            : ''
                                    }
                                />
                                <DivLayout
                                    heading={'Task Date'}
                                    data={
                                        siteVisitByIdDetails?.data?.task_date
                                            ? siteVisitByIdDetails?.data?.task_date
                                            : ''
                                    }
                                />
                                <DivLayout
                                    heading={'Type'}
                                    data={
                                        siteVisitByIdDetails?.data?.task_type
                                            ? siteVisitByIdDetails?.data?.task_type
                                            : localization.na
                                    }
                                />
                                <DivLayout
                                    heading={'Requested By'}
                                    data={
                                        siteVisitByIdDetails?.data?.requested_by
                                            ? siteVisitByIdDetails?.data?.requested_by
                                            : localization.na
                                    }
                                />
                                <DivLayout
                                    heading={'Distance'}
                                    data={
                                        siteVisitByIdDetails?.data?.distance_in_km
                                            ? siteVisitByIdDetails?.data?.distance_in_km
                                            : localization.na
                                    }
                                />
                                <DivLayout
                                    heading={'Poc Name'}
                                    data={
                                        siteVisitByIdDetails?.data?.poc_name
                                            ? siteVisitByIdDetails?.data?.poc_name
                                            : localization.na
                                    }
                                />

                            </div>
                        </div>
                    </div>

                    <div className="panel-card">
                        <div className="panel-heading">{localization.document}</div>
                        <div className="panel-body">
                            <div className="details-listing">
                                {siteVisitByIdDetails && siteVisitByIdDetails.data && Object.keys(siteVisitByIdDetails?.data).length !== 0 &&
                                    siteVisitByIdDetails.data.documents !== null && siteVisitByIdDetails.data.documents.map((val, i) => {
                                        return (
                                            <DocumentView
                                                title={'Document ' + (i + 1)}
                                                attachment={val}
                                            />
                                        )
                                    })}
                            </div>
                        </div>
                    </div>
                </>
            }

        </Layout>
    );
};

export default SiteVisitDetails;
